import module from 'app/module.js'
import template from './template.html'

class SearchboxListaItemMovimientoComponent {
  data = null
}

module.component('searchboxListaItemMovimiento', {
  controller: SearchboxListaItemMovimientoComponent,
  template,
  bindings: {
    data: '<',
  },
})



// WEBPACK FOOTER //
// ./src/app/components/searchbox/lista/item/movimiento/component.js